<template>
  <div>
    <div class="prodect-nav" v-if="navShow">
      <div class="order-pointer" @click="changeOrder(0)">默认排序</div>
      <div @click="changeOrder(1)" class="order-pointer">
        上架时间<span
          class="asc-order"
          :class="onShelfTime ? '' : 'des-order'"
        ></span>
      </div>
      <div @click="changeOrder(2)" class="order-pointer">
        价格<span
          class="asc-order"
          :class="priceOrder ? '' : 'des-order'"
        ></span>
      </div>
      <div @click="changeOrder(3)" class="order-pointer">
        浏览量<span
          class="asc-order"
          :class="wathOrder ? '' : 'des-order'"
        ></span>
      </div>
      <div @click="changeOrder(4)" class="order-pointer">
        点赞数<span
          class="asc-order"
          :class="likeNumOrder ? '' : 'des-order'"
        ></span>
      </div>
      <div>
        为你找到了<em>{{ allPageCount }}</em
        >个结果
      </div>
    </div>
    <div
      class="product-item"
      v-for="(item1, index1) in proItemList"
      :key="`productlist${index1}`"
    >
      <ul ref="listPannel" v-if="proItemList && proItemList.length > 0">
        <li
          v-for="item in item1"
          :key="item.service_id"
          @click="jumpToDetail(item.service_id)"
        >
          <h3 class="resultTip" :title="item.service_name">
            {{ item.service_name }}
          </h3>
          <div
            class="key-word"
            v-if="item.service_keyword && item.service_keyword.length > 0"
          >
            <span v-for="(it, index) in item.service_keyword" :key="index">{{
              it
            }}</span>
          </div>
          <p :title="item.content" class="resultTip">{{ item.content }}</p>
          <div
            class="item-price"
            v-if="item.price != -1 && item.price != null && item.price != ''"
          >
            <span>￥</span>{{ item.price
            }}<span
              >/{{
                item.combo_type == 0
                  ? item.invoke_times + '次'
                  : item.used_length + '天'
              }}</span
            >
            <div class="service-button">查看详情</div>
          </div>
          <div
            class="item-price item-text"
            v-if="item.price == -1 || item.price == null || item.price == ''"
          >
            联系商务报价
            <div class="service-button">查看详情</div>
          </div>
          <div
            :class="
              item.service_promotion_label == 1
                ? 'is-new'
                : item.service_promotion_label == 2
                ? 'is-hot'
                : ''
            "
            v-if="item.service_promotion_label > 0"
          ></div>
        </li>
      </ul>
    </div>
    <div class="load-more-btn" v-if="loadMoreText">{{ loadMoreText }}</div>
  </div>
</template>
<script>
import checkedImg from '@/assets/service/checkbox_checked.png'
import unCheckedImg from '@/assets/service/checkbox_unchecked.png'
import { queryMarketDetailList } from '@/api/market.js'
import _ from 'lodash'
export default {
  name: 'serviceProduct',
  data() {
    
    return {
      loadMoreText: '', //加载btn
      proItemList: [],
      // searchValue: "", //搜索字段
      onShelfTime: true, //上架时间排序
      priceOrder: true, //价格排序
      wathOrder: true, //浏览量排序
      likeNumOrder: true, // 点赞数排序
      prodectNav: {
        //默认排序字段
        onShelfTimeValue: '',
        priceOrderValue: '',
        wathOrderValue: '',
        likeNumOrderValue: ''
      },
      newVal: {
        serviceContent: '',
        serviceIndustry: '',
        alternationId: '',
        classifyId: ''
      },
      alternationId: [], //支付方式
      serviceIndustry: [], //通用行业
      classifyId: [], //产品分类
      childClassifyId: [], //二级分类
      allPageCount: '', //总条数
      navShow: false, // 排序搜索栏是否出现

      page: 1, //当前页
      isLoading: true //是否加载
    }
  },
  watch: {
    count: {
      handler: function(val, oldVal) {
        if (val != oldVal) {
          this.page = 1
          this.getQueryMarketList()
        }
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    count() {
      let oldVal = this.$store.state.product
      // this.searchValue = oldVal.searKeyWord;
      let url = location.href
      this.newVal = {}
      this.alternationId = []
      this.serviceIndustry = []
      this.classifyId = []
      this.childClassifyId = []
      this.alternationId = []
      if (url.indexOf('serviceProduct') >= 0) {
        if (oldVal.request.length > 0) {
          oldVal.request.forEach(ele => {
            if (JSON.stringify(ele).indexOf('classify_id') >= 0) {
              this.classifyId.push(ele.classify_id)
              if (
                JSON.stringify(ele).indexOf('beSelectedChildId') >= 0 &&
                ele.beSelectedChildId != ''
              ) {
                this.childClassifyId.push(ele.beSelectedChildId)
              }
            } else if (JSON.stringify(ele).indexOf('dict_item_code') >= 0) {
              this.serviceIndustry.push(ele.dict_item_code)
            } else if (JSON.stringify(ele).indexOf('id') >= 0) {
              this.alternationId.push(ele.id)
            }
          })
        }
      }
      this.newVal = {
        classifyId: JSON.stringify(this.classifyId),
        serviceIndustry: JSON.stringify(this.serviceIndustry),
        alternationId: JSON.stringify(this.alternationId),
        // serviceContent: this.searchValue,
        childClassifyId: JSON.stringify(this.childClassifyId)
      }
      return this.newVal
    }
  },
  mounted() {
    //是否显示排序搜索栏
    let isUrl = location.href
    isUrl.indexOf('serviceProduct') >= 0
      ? (this.navShow = true)
      : (this.navShow = false)
    // this.getQueryMarketList();

    window.addEventListener('scroll', this.lazyLoading)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.lazyLoading)
  },
  methods: {
    //滑动加载
    lazyLoading: _.debounce(function() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      let clientHeight = document.documentElement.clientHeight
      let scrollHeight = document.documentElement.scrollHeight
      if (scrollTop + clientHeight >= scrollHeight * 0.9 && this.isLoading) {
        this.isLoading = false
        this.page += 1
        this.$refs.listPannel.className = ''
        this.getQueryMarketList()
      }
    }, 200),
    // 排序
    changeOrder(num) {
      if (num == 0) {
        this.onShelfTime = true
        this.wathOrder = true
        this.priceOrder = true
        this.likeNumOrder = true
        this.prodectNav.onShelfTimeValue = ''
        this.prodectNav.priceOrderValue = ''
        this.prodectNav.wathOrderValue = ''
        this.prodectNav.likeNumOrderValue = ''
      } else if (num == 1) {
        this.onShelfTime = !this.onShelfTime
        this.priceOrder = true
        this.wathOrder = true
        this.likeNumOrder = true
        if (this.onShelfTime) {
          this.prodectNav.onShelfTimeValue = 1
          this.prodectNav.priceOrderValue = ''
          this.prodectNav.wathOrderValue = ''
          this.prodectNav.likeNumOrderValue = ''
        } else {
          this.prodectNav.onShelfTimeValue = 0
          this.prodectNav.priceOrderValue = ''
          this.prodectNav.wathOrderValue = ''
          this.prodectNav.likeNumOrderValue = ''
        }
      } else if (num == 2) {
        // 内部版本隐藏价格
        this.priceOrder = !this.priceOrder
        this.onShelfTime = true
        this.wathOrder = true
        this.likeNumOrder = true
        if (this.priceOrder) {
          this.prodectNav.onShelfTimeValue = ''
          this.prodectNav.priceOrderValue = 1
          this.prodectNav.wathOrderValue = ''
          this.prodectNav.likeNumOrderValue = ''
        } else {
          this.prodectNav.onShelfTimeValue = ''
          this.prodectNav.priceOrderValue = 0
          this.prodectNav.wathOrderValue = ''
          this.prodectNav.likeNumOrderValue = ''
        }
      } else if (num == 3) {
        this.wathOrder = !this.wathOrder
        this.priceOrder = true
        this.likeNumOrder = true
        this.onShelfTime = true
        if (this.wathOrder) {
          this.prodectNav.onShelfTimeValue = ''
          this.prodectNav.priceOrderValue = ''
          this.prodectNav.wathOrderValue = 1
          this.prodectNav.likeNumOrderValue = ''
        } else {
          this.prodectNav.onShelfTimeValue = ''
          this.prodectNav.priceOrderValue = ''
          this.prodectNav.wathOrderValue = 0
          this.prodectNav.likeNumOrderValue = ''
        }
      } else if (num == 4) {
        this.likeNumOrder = !this.likeNumOrder
        this.priceOrder = true
        this.wathOrder = true
        this.onShelfTime = true
        if (this.likeNumOrder) {
          this.prodectNav.onShelfTimeValue = ''
          this.prodectNav.wathOrderValue = ''
          this.prodectNav.priceOrderValue = ''
          this.prodectNav.likeNumOrderValue = 1
        } else {
          this.prodectNav.onShelfTimeValue = ''
          this.prodectNav.wathOrderValue = ''
          this.prodectNav.priceOrderValue = ''
          this.prodectNav.likeNumOrderValue = 0
        }
      }
      this.page = 1
      this.getQueryMarketList()
    },
    // 获取数据
    getQueryMarketList() {
      let data = {
        classify_id: JSON.parse(this.newVal.classifyId) || [], //服务分类ID
        child_classify_id: JSON.parse(this.newVal.childClassifyId) || [], //二级分类Id
        service_industry: JSON.parse(this.newVal.serviceIndustry) || [], //行业类型
        alternation_id: JSON.parse(this.newVal.alternationId) || [], //交付方式ID
        order_time: this.prodectNav.onShelfTimeValue, //按照上架时间排序 （0-降序，1-升序）
        order_pageviews: this.prodectNav.wathOrderValue, //浏览量排序（0-降序，1-升序）
        order_vote: this.prodectNav.likeNumOrderValue, //点赞量排序（0-降序，1-升序）
        order_price: this.prodectNav.priceOrderValue, //按照价格排序 （0-降序，1-升序）
        service_content: this.newVal.serviceContent || '', //服务介绍-搜索关键字
        page_size: '20', //每页条数
        page_num: this.page, //当前页
        is_show: '1', //是否展示
        label_keyword: '', //标签关键词//暂时用不到
        open_level: '', //服务开放级别 1:个人/企业 2：企业    //暂时用不到
        business_model: '' //套餐模式0：付费1：需商务  //暂时用不到
      }
      queryMarketDetailList(data).then(res => {
        if (res) {
          if (this.page == 1) {
            this.proItemList = []
          }
          let list = res.list
          this.allPageCount = res.total
          res.page_num < res.pages
            ? ((this.loadMoreText = '继续滑动鼠标加载更多'),
              (this.isLoading = true))
            : ((this.loadMoreText = '没有更多啦!'), (this.isLoading = false))
          for (let i = 0; i < list.length; i++) {
            //关键字过滤
            if (list[i].service_keyword != '') {
              if (
                list[i].service_keyword == ',' ||
                list[i].service_keyword == '，'
              ) {
                list[i].service_keyword = []
              } else {
                list[i].service_keyword = list[i].service_keyword.split(',')
              }
            }
            // this.proItemList.push(list[i]);
          }
          this.proItemList.push(list)
          this.$nextTick(() => {
            this.$refs.listPannel[this.page - 1].className =
              'animating-enter-down'
          })
        }
      })
    },
    //跳转详情
    jumpToDetail(id) {
      // this.$router.push({
      //   path: "/service/serviceDetail/" + id
      // });

      let routeData = this.$router.resolve({
        path: '/service/serviceDetail/' + id
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.com-nav {
  height: 50px;
  background: url('../../../assets/service/bg.png') no-repeat 0 0;
  background-size: 100% 50px;
}
.search-bar {
  height: 118px;
  background: #eff8ff;
}
.main-contian {
  width: 1200px;
  margin: auto;
  overflow: hidden;
  font-size: 14px;
  color: #333;
  .prodect-nav {
    height: 40px;
    background: #f8f8f8;
    padding: 10px 15px;
    margin-bottom: 30px;
    div {
      display: inline-block;
      &:nth-child(1) {
        color: #333;
      }
      margin-right: 40px;
      color: #666;
      &:last-child {
        float: right;
        margin-right: 0px;
        color: #999;
        em {
          color: #3060ff;
          font-style: normal;
        }
      }
      position: relative;
      .asc-order,
      .des-order {
        display: inline-block;
        width: 9px;
        height: 14px;
        position: absolute;
        top: 3px;
        right: -17px;
        cursor: pointer;
        background: url('../../../assets/service/arr_up.png') no-repeat 0 0;
      }
      .des-order {
        background: url('../../../assets/service/arr_down.png') no-repeat 0 0;
      }
    }
    .order-pointer {
      cursor: pointer;
    }
  }
}
.product-item {
  > ul {
    display: flex;
    display: -webkit-flex;
    flex-flow: row wrap;
    li {
      background: #fff;
      width: 260px;
      height: 260px;
      padding: 15px;
      border: 1px solid #e5e5e5;
      margin-bottom: 30px;
      position: relative;
      margin-right: 50px;
      &:nth-child(4n) {
        margin-right: 0;
      }
      h3 {
        font-weight: 700;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .key-word {
        width: 240px;
        height: 21px;
        margin: 12px 0 18px 0;
        overflow: hidden;
        span {
          display: inline-block;
          // margin-bottom: 2px;
          // background: rgba(48, 140, 255, 0.11);
          // border-radius: 11px;
          // margin-right: 8px;
          // font-size: 12px;
          // color: #3060ff;
          // line-height: 12px;
          // padding: 4px 9px;
          // float: left;
          font-size: 12px;
          color: #3060ff;
          letter-spacing: 0.5px;
          height: 20px;
          line-height: 20px;
          max-width: 220px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: rgba(48, 140, 255, 0.11);
          border-radius: 11px;
          padding: 0 9px;
          margin-right: 8px;
        }
      }
      p {
        color: #6d8195;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        word-break: break-all;
        cursor: pointer;
      }
      .item-price {
        position: absolute;
        bottom: 0;
        left: 0;
        color: #ff595e;
        font-size: 24px;
        font-weight: 700;
        height: 45px;
        width: 260px;
        line-height: 45px;
        padding-left: 15px;
        overflow: hidden;
        span {
          font-size: 14px;
          font-weight: normal;
          &:nth-child(2) {
            color: #999999;
          }
        }
      }
      .item-text {
        font-size: 20px;
      }
      .service-button {
        position: absolute;
        bottom: -45px;
        left: 0;
        width: 260px;
        height: 45px;
        line-height: 45px;
        background-image: linear-gradient(209deg, #0037ff 0%, #4774fe 100%);
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        z-index: -1;
        transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
        font-weight: normal;
      }
      .is-new {
        position: absolute;
        top: -6px;
        right: -12px;
        background: url('../../../assets/service/new.png') no-repeat;
        width: 74px;
        height: 74px;
      }
      .is-hot {
        position: absolute;
        top: -6px;
        right: -12px;
        background: url('../../../assets/service/hot.png') no-repeat;
        width: 74px;
        height: 74px;
      }
      &:hover {
        cursor: pointer;
        box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.11);
        .service-button {
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
.load-more-btn {
  width: 180px;
  height: 40px;
  background: #f8f8f8;
  border-radius: 4px;
  color: #666666;
  line-height: 40px;
  text-align: center;
  margin: 40px auto;
  // &:before {
  //   content: "";
  //   display: inline-block;
  //   font-weight: 700;
  //   margin-right: 5px;
  //   width: 6px;
  //   height: 12.5px;
  //   background: url("../../../assets/service/more_btn.png") no-repeat 0 0;
  // }
}
.animating-enter-down {
  -webkit-animation: re-banner-slide-20 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0s 1
    forwards;
  animation: re-banner-slide-20 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0s 1 forwards;
}
@-webkit-keyframes re-banner-slide-20 {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 20px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
  }
}

@keyframes re-banner-slide-20 {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 20px, 0);
    transform: translate3d(0, 20px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/product/productList.vue